import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable ,  of } from 'rxjs';
import { Router } from '@angular/router';
import { LocalStorage } from '../shared/localstorage.service';

/**
 * @description
 * @class
 */
@Injectable()
export class Logger {

  constructor(private http: HttpClient){}

  log(level: string, message: string){
    return new Promise(resolve => {
      this.http.post(`api/logging/log?message=${message}&level=${level}`,'')
          .subscribe(data => {
              resolve(data);
          });
      setTimeout(() => resolve('An error occured.'), 30000);
  });
  }

  userLog(username: string, message: string){
    return new Promise(resolve => {
        this.http.post(`api/logging/AddUserLog`,{
            UserName: username, Message: message
        })
            .subscribe(data => {
                resolve(data);
            });
        setTimeout(() => resolve('An error occured.'), 30000);
    });
  }
}
